import React from 'react';
import './styles.scss';

const Screen6 = () => {
  return (
    <div>
      <div className="ibox-content ">
        <div id="rightMenuContentMainDiv" className="">
          <div id="dvStep1" className="ibox-content ">
            <div
              id="subData1"
              className="flex justify-center items-center flex-col text-sm font-normal">
              <h4 className="text-sm font-normal">
                You can also refresh this page in a few minutes.
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Screen6;
